/** Production site URL — keep in sync with hosting and og:url in index.html */
export const SITE_URL = "https://mcdenica.com";

export const SITE_NAME = "Медицински център Деница";

export const DEFAULT_TITLE =
  "Медицински център Деница и Диамед-М | Лаборатория и прегледи в Монтана";

export const DEFAULT_DESCRIPTION =
  "Медицински център Деница в Монтана — прегледи, диагностика, специалисти, лабораторни изследвания и лични лекари.";

export const OG_IMAGE = `${SITE_URL}/logo-web.png`;
